import Box from "@mui/material/Box";
import { useAppStore } from "../../shared/store/app";
import { useT } from "../../shared/i18n";
import { green, red } from "@mui/material/colors";

/**
 * The account section's connectivity state (spec §7). Deliberately not a live
 * region: the offline banner already owns the single `role="status"` slot, so
 * this stays quiet and only states the current mode when read (spec §10).
 */
export function ConnectivityIndicator() {
  const online = useAppStore((s) => s.online);
  const t = useT();
  const color = online ? green[500] : red[500];
  const label = t(online ? "online" : "offline");
  return (
    <Box
      component="span"
      data-testid="connectivity"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: "action.selected",
        color,
      }}
    >
      <Box component="span" aria-hidden sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color }} />
      {label}
    </Box>
  );
}